<template>
  <div :class="classes" v-loading="loading">
    <wt-re-request-tip :re-load="load" v-show="loadFailed"></wt-re-request-tip>
    <pt-page-title title="检测项详情"></pt-page-title>
    <!-- 检测项信息 -->
    <div v-if="detection">
      <pt-sub-title title="检测项信息"></pt-sub-title>
      <pt-form-item class="special" label="中文名称:" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{detection.chineseName}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="英文名称:" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{detection.englishName}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="适用性别:" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{formatConfigSex(detection.gender)}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="类型:" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{formatDetectionCategory(detection.category)}}</span>
      </pt-form-item>
      <pt-form-item class="special" label="标签:" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <el-button size="mini" round v-for="(tag,index) in detection.tags" :key="index" type="primary">
          {{tag}}
        </el-button>
      </pt-form-item>
    </div>
    <!-- 语料 -->
    <detection-corpus-collapse :id="id"></detection-corpus-collapse>
    <!-- 配置 -->
    <detection-config-collapse :id="id"></detection-config-collapse>
    <div class="marginTop">
      <el-button type="primary" @click="goEdit(id,detection)">编辑</el-button>
    </div>

  </div>
</template>

<script>
import detectionCorpusCollapse from 'cps/gene-product/selector/detection-corpus-collapse'
import detectionConfigCollapse from 'cps/gene-product/selector/detection-config-collapse'
import { formatConfigSex, formatDetectionCategory } from 'enumeration/lab-order.js'
const prefixCls = 'pt-detection-detail'
export default {
  name: 'pt-detection-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    icon () {
      return this.adding ? 'el-icon-loading' : 'el-icon-plus'
    }
  },
  data () {
    return {
      id: this.$route.params.id,
      labelWidth: '90px',
      lineHeight: '26',
      // 用于绑定的产品数据对象
      detection: this.$route.params.value ? this.$route.params.value : null,
      // 页面是否在进行数据loading
      loading: false,
      // 是否加载失败，用于显示遮罩层，用户可触发重试
      loadFailed: false,
      showDialog: false,
      dialogTitle: '导入配置'
    }
  },
  components: {
    detectionCorpusCollapse,
    detectionConfigCollapse
  },
  methods: {
    formatDetectionCategory,
    formatConfigSex,
    // goNew () {
    //   // this.$router.push({name:'detection-corpus-new'})
    //   console.log(this.id)
    //   this.$router.push({ name: 'detection-corpus-new', params: { detectionItemId: this.id } })
    // },
    toUpdate () {
      // 将详情数据传递给更新页面
      this.$router.push({ name: 'detection-update', params: { id: this.id, category: this.detection.category, value: this.detection } })
    },
    // 加载详情数据
    load () {
      this.loading = true
      this.loadFailed = false
      this.$store.dispatch('getDetection', this.$route.params.id).then((response) => {
        this.loadFailed = false
        this.loading = false
        this.detection = response.data
        console.log('---------detection', this.detection)
      }).catch((error) => {
        this.loading = false
        this.loadFailed = true
        this.$message.error(error)
      })
    },
    // 删除产品
    removeDetection () {
      this.$confirm('此操作将永久删除检测项' + this.detection.chineseName + ', 是否继续?', '提示', { type: 'warning' })
        .then((response) => { // 向请求服务端删除
          // delete_detection(this.id)
          //   .then((response) => {
          //     this.$message.success('成功删除了检测项' + this.detection.chineseName + '!')
          //     history.go(-1)
          //   })
          //   .catch((error) => {
          //     console.error(error)
          //     this.$message.error('删除失败!')
          //   })
        }).catch(() => {
          this.$message.info('已取消操作!')
        })
    },
    goEdit (id, data) {
      // 将详情数据传递给更新页面
      this.$router.push({ name: 'detection-update', params: { id: id, category: data.category } })
    },
    update (val) {
      this.showDialog = val
    }
  },
  created () {
    this.id = this.$route.params.id
    // 如果父组件没有传入产品数据，则本页面根据id进行获取
    if (!this.detection) {
      this.load()
    }
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
@import '~less/var.less';
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-detection-detail{
  .special >span{
    color:@mainColor;
  }
  .el-collapse{
    margin-bottom: 20px;
    margin-left: 20px;
    padding-left: 20px;
    border: 0.01rem solid #ebeef5;
	}
	.table{
		>br{
			display: none;
		}
	}
}
</style>
